import Amplify from 'aws-amplify';
import AWSAppSyncClient, { AUTH_TYPE } from 'aws-appsync';
import gql from 'graphql-tag';
import {
  INTEGRATION_SERVICE_V0_AWS_CONFIG,
  INTEGRATION_SERVICE_V1_AWS_CONFIG,
  INTEGRATION_SERVICE_V2_AWS_CONFIG,
  INTEGRATION_SERVICE_V3_AWS_CONFIG,
  INTEGRATION_SERVICE_V4_AWS_CONFIG,
  PROPERTY_SERVICE_V0_AWS_CONFIG,
  PROPERTY_SERVICE_V6_AWS_CONFIG,
} from '../env/Configurations';
import {
  createAppConfigurationMutation,
  createOrUpdateRestaurantConfig,
  createOrUpdateSpaReservationConfig,
  createOrUpdateTelephonyConfig,
  createRoomConfigurations,
  createTemplate,
  deleteConnectionConfig,
  DeleteRoomConfigurations,
  deleteTemplate,
  duplicateTemplate,
  saveGlobalDoorCameraConfigs,
  updateAppConfigurationMutation,
  updateHotelSystemsDigitalCheckinConfig,
  updateHotelSystemSettings,
  UpdateRoomConfigurations,
  updateRoomReservationConfigs,
  updateTemplate,
} from '../graphql/configurations/mutations';
import {
  getHotelSystemsDigitalCheckinConfig,
  getHotelSystemSettings,
  getIntegrationConfigs,
  getIntegrationStatus,
  getListTemplates,
  getRestaurantConfigs,
  getRestaurantDetails,
  GetRoomConfigDetailsByHotelIdAndRoomId,
  GetRoomListByHotelId,
  getRoomReservationDetails,
  getSpaList,
  getSpaReservations,
  getTelephonyConfig,
  listTelephonyOptions,
  getAppConfigurationsListQuery,
} from '../graphql/configurations/queries';
import {
  createVendor,
  deleteVendor,
  duplicateVendor,
  saveGlobalDdkConfigs,
  saveGlobalDefaultConfigs,
  saveGlobalDndConfigs,
  saveGlobalMmrConfigs,
  updateEntertainmentConfigModules,
  updateGuestRoomExpConfigModules,
  updateHotelServiceConfigModules,
  updateHotelSystemsModuleConfigurations,
  updateVendor,
} from '../graphql/mutations';
import {
  GetCategorizeVendors,
  getGreGlobalConfigs,
  getHotelSystemsModuleSummary,
} from '../graphql/queries';
import { getCurrentJwtToken } from './authUtils';

Amplify.configure({
  ...INTEGRATION_SERVICE_V0_AWS_CONFIG,
});

const client = new AWSAppSyncClient({
  url: INTEGRATION_SERVICE_V0_AWS_CONFIG.aws_appsync_graphqlEndpoint,
  region: INTEGRATION_SERVICE_V0_AWS_CONFIG.region,
  auth: {
    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    jwtToken: async () => await getCurrentJwtToken(),
  },
  disableOffline: true,
  cacheOptions: {
    addTypename: false,
  },
});

const clientProperty = new AWSAppSyncClient({
  url: PROPERTY_SERVICE_V0_AWS_CONFIG.aws_appsync_graphqlEndpoint,
  region: PROPERTY_SERVICE_V0_AWS_CONFIG.region,
  auth: {
    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    jwtToken: async () => await getCurrentJwtToken(),
  },
  disableOffline: true,
  cacheOptions: {
    addTypename: false,
  },
});

const integrationServiceV1Client = new AWSAppSyncClient({
  url: INTEGRATION_SERVICE_V1_AWS_CONFIG.aws_appsync_graphqlEndpoint,
  region: INTEGRATION_SERVICE_V1_AWS_CONFIG.region,
  auth: {
    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    jwtToken: async () => await getCurrentJwtToken(),
  },
  disableOffline: true,
  cacheOptions: {
    addTypename: false,
  },
});

const integrationServiceV2Client = new AWSAppSyncClient({
  url: INTEGRATION_SERVICE_V2_AWS_CONFIG.aws_appsync_graphqlEndpoint,
  region: INTEGRATION_SERVICE_V2_AWS_CONFIG.region,
  auth: {
    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    jwtToken: async () => await getCurrentJwtToken(),
  },
  disableOffline: true,
  cacheOptions: {
    addTypename: false,
  },
});

const integrationServiceV3Client = new AWSAppSyncClient({
  url: INTEGRATION_SERVICE_V3_AWS_CONFIG.aws_appsync_graphqlEndpoint,
  region: INTEGRATION_SERVICE_V3_AWS_CONFIG.region,
  auth: {
    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    jwtToken: async () => await getCurrentJwtToken(),
  },
  disableOffline: true,
  cacheOptions: {
    addTypename: false,
  },
});

const integrationServiceV4Client = new AWSAppSyncClient({
  url: INTEGRATION_SERVICE_V4_AWS_CONFIG.aws_appsync_graphqlEndpoint,
  region: INTEGRATION_SERVICE_V4_AWS_CONFIG.region,
  auth: {
    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    jwtToken: async () => await getCurrentJwtToken(),
  },
  disableOffline: true,
  cacheOptions: {
    addTypename: false,
  },
});

const integrationServiceV6Client = new AWSAppSyncClient({
  url: PROPERTY_SERVICE_V6_AWS_CONFIG.aws_appsync_graphqlEndpoint,
  region: PROPERTY_SERVICE_V6_AWS_CONFIG.region,
  auth: {
    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    jwtToken: async () => await getCurrentJwtToken(),
  },
  disableOffline: true,
  cacheOptions: {
    addTypename: false,
  },
});

export const updateDigitalCheckinConfigs = async (digitalConfig) => {
  return await client.mutate({
    mutation: gql(updateHotelSystemsDigitalCheckinConfig),
    variables: {
      hotelId: digitalConfig?.hotelId,
      personalisation: digitalConfig?.personalisation,
      checkInAvailability: digitalConfig?.checkInAvailability,
      accompanyingGuestDetails: digitalConfig?.accompanyingGuestDetails,
      covid19Documents: digitalConfig?.covid19Documents,
      eRegistrationDestination: digitalConfig?.eRegistrationDestination,
      eRegistrationForm: digitalConfig?.eRegistrationForm,
      guestDocumentTypes: digitalConfig?.guestDocumentTypes,
      holdAmountConfig: digitalConfig?.holdAmountConfig,
      apiIntegration: digitalConfig?.apiIntegration,
      integrationSource: digitalConfig?.integrationSource,
    },
  });
};

export const updateRoomReservation = async (roomReservation) => {
  return await client.mutate({
    mutation: gql(updateRoomReservationConfigs),
    variables: {
      hotelId: roomReservation?.hotelId,
      payAtProperty: roomReservation.payAtProperty,
      payNow: roomReservation.payNow,
      payment: roomReservation.payment,
      promoCode: roomReservation.promoCode,
      roomUpgrades: roomReservation.roomUpgrades,
      modifyBooking: roomReservation.modifyBooking,
      cancelBooking: roomReservation.cancelBooking,
      integrationSource: roomReservation?.integrationSource,
      integrationSourceType: roomReservation?.integrationSourceType,
      apiIntegrationHotelId: roomReservation?.apiIntegrationHotelId,
      apiIntegrationURL: roomReservation?.apiIntegrationURL,
    },
  });
};

export const updateHotelSystemSetting = async (hotelSystemSettings) => {
  return await integrationServiceV4Client.mutate({
    mutation: gql(updateHotelSystemSettings),
    variables: {
      hotelId: hotelSystemSettings?.hotelId,
      digitalCheckIn: hotelSystemSettings?.digitalCheckIn,
      digitalCheckOut: hotelSystemSettings?.digitalCheckOut,
      housekeeping: hotelSystemSettings?.housekeeping,
      inRoomDinning: hotelSystemSettings?.inRoomDinning,
      roomReservations: hotelSystemSettings?.roomReservations,
      spaReservation: hotelSystemSettings?.spaReservation,
      tableReservation: hotelSystemSettings?.tableReservation,
      telephony: hotelSystemSettings?.telephony,
      loyalty: hotelSystemSettings?.loyalty,
      payment: hotelSystemSettings?.payment,
      weather: hotelSystemSettings?.weather,
      documentScan: hotelSystemSettings?.documentScan,
      travelService: hotelSystemSettings?.travelService,
      chat: hotelSystemSettings?.chat,
      eventHub: hotelSystemSettings?.eventHub,
      analytics: hotelSystemSettings?.analytics,
      thirdPartyNotificationService: hotelSystemSettings?.thirdPartyNotificationService,
      centralReservationSystem: hotelSystemSettings?.centralReservationSystem,
    },
  });
};

export const getDigitalCheckinConfigs = async (hotelId) => {
  return await client.query({
    query: gql(getHotelSystemsDigitalCheckinConfig),
    variables: {
      hotelId: hotelId,
    },
    fetchPolicy: 'network-only',
  });
};

export const getRoomReservation = async (hotelId) => {
  return await client.query({
    query: gql(getRoomReservationDetails),
    variables: {
      hotelId: hotelId,
    },
    fetchPolicy: 'network-only',
  });
};

export const createRoomConfigs = async (hotelId, templateId, roomRange) => {
  return await client.mutate({
    mutation: gql(createRoomConfigurations),
    variables: {
      hotelId: hotelId,
      templateId: templateId,
      rangeList: roomRange,
    },
  });
};

export const deleteExisitingTemplate = async (hotelId, templateId) => {
  return await client.mutate({
    mutation: gql(deleteTemplate),
    variables: {
      hotelId: hotelId,
      id: templateId,
    },
  });
};

export const duplicateExisitingTemplate = async (hotelId, templateId) => {
  return await client.mutate({
    mutation: gql(duplicateTemplate),
    variables: {
      hotelId: hotelId,
      id: templateId,
    },
  });
};

export const duplicateExisitingVendor = async (vendorId, currentHotelId, requestHotelId) => {
  return await client.mutate({
    mutation: gql(duplicateVendor),
    variables: {
      vendorId: vendorId,
      currentHotelId: currentHotelId,
      requestHotelId: requestHotelId,
    },
  });
};

export const createNewVendor = async (hotelId, name, type, attributes) => {
  return await client.mutate({
    mutation: gql(createVendor),
    variables: {
      hotelId: hotelId,
      name: name,
      type: type,
      attributes: attributes,
    },
  });
};

export const updateExistingVendor = async (id, hotelId, name, type, attributes) => {
  return await client.mutate({
    mutation: gql(updateVendor),
    variables: {
      id: id,
      hotelId: hotelId,
      name: name,
      type: type,
      attributes: attributes,
    },
  });
};

export const deleteExisitingVendor = async (hotelId, id) => {
  return await client.mutate({
    mutation: gql(deleteVendor),
    variables: {
      hotelId: hotelId,
      id: id,
    },
  });
};

export const getAllVendors = async (hotelId) => {
  return await client.query({
    query: gql(GetCategorizeVendors),
    variables: {
      hotelId: hotelId,
    },
    fetchPolicy: 'network-only',
  });
};

export const confirmHotelSystemsModuleConfigurations = async (hotelId, configs) => {
  return await client.mutate({
    mutation: gql(updateHotelSystemsModuleConfigurations),
    variables: {
      hotelId: hotelId,
      hotelServiceModules: configs.hotelServiceModules,
      guestRoomExpModules: configs.guestRoomExpModules,
      entertainmentModules: configs.entertainmentModules,
    },
  });
};

export const updateHotelServiceModules = async (hotelId, hotelServiceModules) => {
  return await client.mutate({
    mutation: gql(updateHotelServiceConfigModules),
    variables: {
      hotelId: hotelId,
      hotelServiceModules: hotelServiceModules,
    },
  });
};

export const updateEntertainmentModules = async (hotelId, entertainmentModules) => {
  return await client.mutate({
    mutation: gql(updateEntertainmentConfigModules),
    variables: {
      hotelId: hotelId,
      entertainmentModules: entertainmentModules,
    },
  });
};

export const updateGuestRoomExpModules = async (hotelId, guestRoomExpModules) => {
  return await client.mutate({
    mutation: gql(updateGuestRoomExpConfigModules),
    variables: {
      hotelId: hotelId,
      guestRoomExpModules: guestRoomExpModules,
    },
  });
};

export const getHotelSystemsModuleSummaryData = async (hotelId) => {
  return await client.query({
    query: gql(getHotelSystemsModuleSummary),
    variables: {
      hotelId: hotelId,
    },
    fetchPolicy: 'network-only',
  });
};

export const getGreGlobalConfigsByHotelId = async (hotelId) => {
  return await client.query({
    query: gql(getGreGlobalConfigs),
    variables: {
      hotelId: hotelId,
    },
    fetchPolicy: 'network-only',
  });
};

export const saveOrUpdateGlobalDefaultConfigs = async (hotelId, obj) => {
  return await client.mutate({
    mutation: gql(saveGlobalDefaultConfigs),
    variables: {
      hotelId: hotelId,
      id: obj.id,
      hostingPref: obj.hostingPref,
      languages: obj.languages,
      serverConfigType: obj.serverConfigType,
    },
  });
};
export const saveOrUpdateGlobalDndConfigs = async (hotelId, obj) => {
  return await client.mutate({
    mutation: gql(saveGlobalDndConfigs),
    variables: {
      hotelId: hotelId,
      id: obj.id,
      code: obj.code,
      protocol: obj.protocol,
      provider: obj.provider,
    },
  });
};

export const getListTemplatesData = async (hotelId) => {
  return await client.query({
    query: gql(getListTemplates),
    variables: {
      hotelId: hotelId,
    },
    fetchPolicy: 'network-only',
  });
};

export const createNewTempalte = async (templateCreateInput) => {
  return await client.mutate({
    mutation: gql(createTemplate),
    variables: {
      hotelId: templateCreateInput?.hotelId,
      name: templateCreateInput?.name,
      doorCameraEnabled: templateCreateInput.doorCameraEnabled,
      thermostatVendor: templateCreateInput.thermostatVendor,
      curtainVendor: templateCreateInput.curtainsVendor,
      lightVendor: templateCreateInput.lightsVendor,
      sceneVendor: templateCreateInput.scenesVendor,
      doorLockVendor: templateCreateInput.doorLockVendor,
      doorLock: templateCreateInput.doorLock,
      areas: templateCreateInput.areas,
    },
  });
};

export const updateExisitingTempalte = async (templateId, templateUpdateInput) => {
  return await client.mutate({
    mutation: gql(updateTemplate),
    variables: {
      hotelId: templateUpdateInput?.hotelId,
      id: templateId,
      name: templateUpdateInput?.name,
      doorCameraEnabled: templateUpdateInput.doorCameraEnabled,
      thermostatVendor: templateUpdateInput.thermostatVendor,
      curtainVendor: templateUpdateInput.curtainsVendor,
      lightVendor: templateUpdateInput.lightsVendor,
      sceneVendor: templateUpdateInput.scenesVendor,
      doorLockVendor: templateUpdateInput.doorLockVendor,
      doorLock: templateUpdateInput.doorLock,
      areas: templateUpdateInput.areas,
    },
  });
};

export const saveOrUpdateGlobalDdkConfigs = async (hotelId, obj) => {
  return await client.mutate({
    mutation: gql(saveGlobalDdkConfigs),
    variables: {
      hotelId: hotelId,
      id: obj.id,
      code: obj.code,
      protocol: obj.protocol,
      provider: obj.provider,
    },
  });
};

export const saveOrUpdateGlobalMmrConfigs = async (hotelId, obj) => {
  return await client.mutate({
    mutation: gql(saveGlobalMmrConfigs),
    variables: {
      hotelId: hotelId,
      id: obj.id,
      code: obj.code,
      protocol: obj.protocol,
      provider: obj.provider,
    },
  });
};

export const getHotelRoomList = async (hotelId) => {
  return await client.query({
    query: gql(GetRoomListByHotelId),
    variables: {
      hotelId: hotelId,
    },
    fetchPolicy: 'network-only',
  });
};

export const getHotelRoomConfigurationDetails = async (hotelId, roomId) => {
  return await client.query({
    query: gql(GetRoomConfigDetailsByHotelIdAndRoomId),
    variables: {
      hotelId: hotelId,
      roomId: roomId,
    },
    fetchPolicy: 'network-only',
  });
};

export const saveOrUpdateRoomConfigs = async (hotelId, roomId, type, obj) => {
  return await client.mutate({
    mutation: gql(UpdateRoomConfigurations),
    variables: {
      hotelId: hotelId,
      roomId: roomId,
      area: type === 'AREA' ? obj : null,
      dnd: type === 'DND' ? obj : null,
      ddk: type === 'DDK' ? obj : null,
      mmr: type === 'MMR' ? obj : null,
      dc: type === 'DC' ? obj : null,
      doorLock: type === 'DoorLock' ? obj : null,
    },
  });
};

export const deleteGRERoom = async (hotelId, roomId) => {
  return await client.mutate({
    mutation: gql(DeleteRoomConfigurations),
    variables: {
      hotelId: hotelId,
      roomId: roomId,
    },
  });
};

export const getListSpa = async (hotelId) => {
  return await clientProperty.query({
    query: gql(getSpaList),
    variables: {
      hotelId: hotelId,
    },
    fetchPolicy: 'network-only',
  });
};

export const getSpaReservationConfigs = async (hotelId) => {
  return await client.query({
    query: gql(getSpaReservations),
    variables: {
      hotelId: hotelId,
    },
    fetchPolicy: 'network-only',
  });
};

export const createOrUpdateSpaReservation = async (payload) => {
  return await client.mutate({
    mutation: gql(createOrUpdateSpaReservationConfig),
    variables: {
      hotelId: payload.hotelId,
      spaId: payload.spaId,
      pos: payload.pos,
      treatmentList: payload.treatmentList,
      multipleHours: payload.multipleHours,
      booking: payload.booking,
    },
  });
};

export const getRestaurants = async (hotelId) => {
  return await clientProperty.query({
    query: gql(getRestaurantDetails),
    variables: {
      hotelId: hotelId,
    },
    fetchPolicy: 'network-only',
  });
};

export const getRestaurantConfigurations = async (hotelId) => {
  return await client.query({
    query: gql(getRestaurantConfigs),
    variables: {
      hotelId: hotelId,
    },
    fetchPolicy: 'network-only',
  });
};

export const createOrUpdateRestaurantReservation = async (payload, lang) => {
  return await client.mutate({
    mutation: gql(createOrUpdateRestaurantConfig),
    variables: {
      hotelId: payload.hotelId,
      restaurantId: payload.restaurantId,
      lang,
    },
  });
};

export const getTelephonyEpbx = async () => {
  return await integrationServiceV1Client.query({
    query: gql(listTelephonyOptions),
    fetchPolicy: 'network-only',
  });
};

export const getTelephonyConfigurator = async (hotelId) => {
  return await integrationServiceV1Client.query({
    query: gql(getTelephonyConfig),
    variables: {
      hotelId: hotelId,
    },
    fetchPolicy: 'network-only',
  });
};

export const getHotelSystemSetting = async (hotelId) => {
  return await integrationServiceV4Client.query({
    query: gql(getHotelSystemSettings),
    variables: {
      hotelId: hotelId,
    },
    fetchPolicy: 'network-only',
  });
};

export const createTelephonyConfig = async (payload) => {
  return await integrationServiceV1Client.mutate({
    mutation: gql(createOrUpdateTelephonyConfig),
    variables: {
      epbx: payload.epbx,
      hotelId: payload.hotelId,
      portTLS: payload.portTLS,
      portTLSSecondary: payload.portTLSSecondary,
      sbcA1: payload.sbcA1,
      sbcEmsServer: payload.sbcEmsServer,
      sbcEmsServerSecondary: payload.sbcEmsServerSecondary,
      securityModule: payload.securityModule,
      sessionManager: payload.sessionManager,
      sessionManagerSecondary: payload.sessionManagerSecondary,
      sipDomain: payload.sipDomain,
    },
  });
};

export const createGlobalDoorCamera = async (payload) => {
  return await integrationServiceV1Client.mutate({
    mutation: gql(saveGlobalDoorCameraConfigs),
    variables: {
      provider: payload.provider,
      username: payload.username,
      password: payload.password,
      ipAddress: payload.ipAddress,
      port: payload.port,
      hotelId: payload.hotelId,
    },
  });
};

export const getIntegrationConfiguration = async (configName) => {
  return await integrationServiceV2Client.query({
    query: gql(getIntegrationConfigs),
    variables: {
      configName: configName,
    },
    fetchPolicy: 'network-only',
  });
};

export const getIntegrationStatusByHotelId = async (hotelId) => {
  return await integrationServiceV2Client.query({
    query: gql(getIntegrationStatus),
    variables: {
      hotelId: hotelId,
    },
    fetchPolicy: 'network-only',
  });
};

const createClientWithBaseUrl = (url) => {
  return new AWSAppSyncClient({
    url: url,
    region: PROPERTY_SERVICE_V0_AWS_CONFIG.region,
    auth: {
      type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
      jwtToken: async () => await getCurrentJwtToken(),
    },
    disableOffline: true,
    cacheOptions: {
      addTypename: false,
    },
  });
};

export const vendorConnect = async (query, variables, baseUrl) => {
  const createdClient = createClientWithBaseUrl(baseUrl);
  var queryType = query.split(' ')[0];

  if (queryType === 'query') {
    return await createdClient.query({
      query: gql(query),
      variables: variables,
    });
  }
  return await createdClient.mutate({
    mutation: gql(query),
    variables: variables,
  });
};

export const vendorReset = async (hotelId, integrationType) => {
  return await integrationServiceV3Client.mutate({
    mutation: gql(deleteConnectionConfig),
    variables: {
      hotelId: hotelId,
      integrationType: integrationType,
    },
  });
};

export const getAppConfigurationsListApi = async (hotelId) => {
  return await integrationServiceV6Client.query({
    query: gql(getAppConfigurationsListQuery),
    variables: {
      hotelId: hotelId,
    },
    fetchPolicy: 'network-only',
  });
};

export const createAppConfigurationsApi = async (payload) => {
  return await integrationServiceV6Client.mutate({
    mutation: gql(createAppConfigurationMutation),
    variables: { ...payload },
  });
};

export const updateAppConfigurationsApi = async (payload) => {
  return await integrationServiceV6Client.mutate({
    mutation: gql(updateAppConfigurationMutation),
    variables: { ...payload },
  });
};
